import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'

Vue.use(VueI18n)

// 支持的语言列表
export const supportedLocales = ['zh', 'en']

// 根据域名获取默认语言
const getDefaultLocale = () => {
  // 在浏览器环境中检查域名
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname
    if (hostname === 'hello-gpt.com') {
      return 'en'
    }
  }
  return 'zh' // 默认中文
}

// 从localStorage获取保存的语言设置
const getSavedLocale = () => {
  if (typeof window !== 'undefined') {
    const savedLocale = localStorage.getItem('trangpt_locale')
    if (savedLocale && supportedLocales.includes(savedLocale)) {
      return savedLocale
    }
  }
  return getDefaultLocale()
}

// 保存语言设置到localStorage
export const saveLocale = (locale) => {
  if (typeof window !== 'undefined' && supportedLocales.includes(locale)) {
    localStorage.setItem('trangpt_locale', locale)
  }
}

// 默认语言
export const defaultLocale = getDefaultLocale()

// 当前语言（优先使用localStorage中的设置）
const currentLocale = getSavedLocale()

// 创建i18n实例
const i18n = new VueI18n({
  locale: currentLocale,
  fallbackLocale: defaultLocale,
  messages: {
    zh,
    en
  }
})

// 扩展i18n实例，添加语言切换方法
i18n.setLocale = function(newLocale) {
  if (supportedLocales.includes(newLocale)) {
    this.locale = newLocale
    saveLocale(newLocale)
  }
}

export default i18n